<template lang="pug">
  v-app
    TokenDialog
    MenuDevelop(v-if="isDevelop")
    router-view(name="login")
    router-view(name="dashboard")
</template>

<script>
  import MenuDevelop from '@/components/develop/MenuDevelop';
  import TokenDialog from '@/components/dialogs/token/TokenDialog';

  export default {
    name: 'App',
    components: {
      MenuDevelop,
      TokenDialog
    },
    data: () => ({
      isDevelop: process.env.NODE_ENV == 'development'
    })
  };
</script>
